import TransportadoraService from "@/services/TransportadoraService";

export const transportadora = {
  namespaced: true,
  state: {
    transportadora: {},
  },
  actions: {
    getTransportadora({ commit }, payload) {
      return TransportadoraService.GetTransportadora(payload).then(
        (transportadora) => {
          return Promise.resolve(transportadora);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTransportadora({ commit }, payload) {
      return TransportadoraService.PostTransportadora(payload).then(
        (transportadora) => {
          return Promise.resolve(transportadora);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTransportadora({ commit }, payload) {
      return TransportadoraService.PutTransportadora(payload).then(
        (transportadora) => {
          return Promise.resolve(transportadora);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTransportadora({ commit }, payload) {
      return TransportadoraService.DeleteTransportadora(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTransportadoraOData({ commit }, payload) {
      return TransportadoraService.GetTransportadoraOData(payload).then(
        (transportadora) => {
          return Promise.resolve(transportadora);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default transportadora;
